import Rating from "@mui/material/Rating";
import { handleAddWatchedProduct } from "../../pages-sections/dashboard/AddWatchedProductPopUp";

import LoggedInFeatureButton from "../CustomButtons/LoggedInFeatureButton";

const Component = (props) => {
  const {
    productEntry,
    user,
    isUpdating,
    setLoadingState,
    handleUpdateUser,
    handleClick,
    ...rest
  } = props;

  const reviewWithRating =
    productEntry?.reviews?.publicReviews?.find(
      (r) => r.reviewDetails.reviewScore
    ) || null;

  const ratingValue = reviewWithRating
    ? reviewWithRating.reviewDetails.reviewScore / 20
    : null;

  return (
    <Rating
      name="product rating"
      size="small"
      precision={0.5}
      value={ratingValue}
      onClick={(e) => {
        if (!user) {
          e.preventDefault();
          handleClick();
        }
      }}
      onChange={async (_event, newValue) => {
        if (user) {
          const reviewScore = newValue * 20;

          const { product, usageStatus } = productEntry;
          if (!usageStatus) {
            await handleAddWatchedProduct(
              product.databaseId,
              {
                product: {
                  title: product.title,
                  href: product.uri,
                  category: product.category.node.slug,
                  imageUrl: product.featuredImage.node.sourceUrl || null,
                },
              },
              user,
              handleUpdateUser,
              "reviewed"
            );
          }
          if (!productEntry.reviews) {
            productEntry.reviews = {};
          }
          if (!productEntry.reviews.publicReviews) {
            productEntry.reviews.publicReviews = [];
          }
          // Ensure that, unless the review already has a score added externally, this gets added as a new review with a score only
          let target = productEntry.reviews.publicReviews?.find(
            (r) => r.reviewDetails.reviewScore
          );

          if (!target) {
            target = {
              reviewDetails: {},
            };
            productEntry.reviews.publicReviews.push(target);
          }
          target.reviewDetails.reviewScore = reviewScore;

          if (!productEntry.usageStatus) {
            productEntry.usageStatus = "reviewed";
          }
          handleUpdateUser({
            type: "review",
            isUpdating,
            event: {
              target: {
                value: {
                  reviewDetails: { reviewScore },
                },
              },
            },
            getTarget: (u) => {
              let targetEntry = u.athleteProducts.edges?.find(
                (e) => e.product?.id === productEntry.product.id
              );

              if (!targetEntry) {
                targetEntry = { product, usageStatus: "reviewed" };
                u.athleteProducts.edges.push(targetEntry);
              }
              if (!targetEntry.reviews) {
                targetEntry.reviews = {};
              }
              if (!targetEntry.reviews.publicReviews) {
                targetEntry.reviews.publicReviews = [];
              }

              return targetEntry.reviews.publicReviews;
            },
            shortcutValue: reviewScore,
            name: "reviewScore",
            index: productEntry.product.id,
            shouldAdd: !target.id,
            isArray: true,
            setLoadingState,
            operation: !target.id ? "create" : "update",
            additionalVars: {
              id: target.id || undefined, // no id if it's a new review
              reviewer: { id: user.databaseId },
              scoreIsExplicit: true,
              reviewedProducts: [productEntry.product.databaseId],
              status: "PUBLISH",
              privacy: user.athleteDetails.isRestricted ? "PRIVATE" : "PUBLIC",
            },
          });
        }
      }}
      {...rest}
    />
  );
};

const ReviewRating = (props) => {
  const type = "reviewButton";
  return (
    <>
      <LoggedInFeatureButton
        {...props}
        type={type}
        Component={Component}
        redirectToPage
      />
    </>
  );
};

export default ReviewRating;
